import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HardHat, Loader2 } from "lucide-react";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) { navigate("/"); return; }
      try {
        const userData = await exchangeSession(sessionId);
        setUser(userData);
        // clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: userData }, replace: true });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/"), 2500);
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#1D4ED8] text-white">
        <HardHat className="h-6 w-6" />
      </div>
      {error ? (
        <p className="mt-5 text-slate-600">Sign-in failed. Redirecting…</p>
      ) : (
        <div className="mt-5 flex items-center gap-2 text-slate-600">
          <Loader2 className="h-4 w-4 animate-spin" /> Signing you in…
        </div>
      )}
    </div>
  );
};

export default AuthCallback;
